import { render, staticRenderFns } from "./IristarHeader.vue?vue&type=template&id=67e1106c&scoped=true&"
import script from "./IristarHeader.vue?vue&type=script&lang=js&"
export * from "./IristarHeader.vue?vue&type=script&lang=js&"
import style0 from "./IristarHeader.vue?vue&type=style&index=0&id=67e1106c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1106c",
  null
  
)

export default component.exports